import { ICurrencyEntityReference } from '../../../basic';
import { GsStructComponent, GsStructPageItems } from '../component';
import { CustomerLoyaltyMode } from './debit-card-detail-component';
import { IMethod } from './../basic/method';
import { IPaginated } from './../basic/paginated';

/** Mirrors the backend enum `DebitCardLoyaltyHistoryKind`. */
export enum DebitCardLoyaltyHistoryKind {
  Plus = 0,
  Minus = 1,
  Cleared = 2,
  VoucherDevalued = 3
}

/** A single booking in the points history of the debit card */
export interface IDebitCardLoyaltyHistoryItem {
  /** ID of the underlying event */
  iD: number;
  /** What the booking was about, the payment info or the reward name */
  title?: string;
  /** When the booking happened */
  dateTime?: string;
  /** Kind of the booking, decides icon and label */
  kind: DebitCardLoyaltyHistoryKind;
  /** Points of the booking, only filled in the points loyalty mode */
  points?: number;
  /** Turnover of the booking, only filled in the turnover loyalty mode */
  amount?: number;
  /** Currency of `amount` */
  currency?: ICurrencyEntityReference;
}

/** Data the backend renders for the DebitCardLoyaltyStatusHistory component */
export interface IDebitCardLoyaltyStatusHistoryRender {
  /** The bookings of the current page */
  items: IPaginated<IDebitCardLoyaltyHistoryItem>;
  /** Customer loyalty mode the debit card settings are running in */
  loyaltyMode: CustomerLoyaltyMode;
  /** Methods that are given with the HTTP request */
  methods: IDebitCardLoyaltyStatusHistoryMethods;
}

/** HTTP methods for the DebitCardLoyaltyStatusHistory component */
export interface IDebitCardLoyaltyStatusHistoryMethods {
  /** Loads a page of bookings */
  populate: IMethod;
}

/** Structure definition for the DebitCardLoyaltyStatusHistory component. */
export interface GsStructDebitCardLoyaltyStatusHistoryComponent
  extends GsStructComponent<IDebitCardLoyaltyStatusHistoryRender>,
    GsStructPageItems {
  /** The specified type-key for this struct */
  componentType: 'DebitCardLoyaltyStatusHistory';
}
